import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useColorModeValue,
} from "@chakra-ui/react";
import EmojiPicker from "emoji-picker-react";
import { RiUserSmileLine } from "react-icons/ri";

function EmojiSelector({ onClick }) {
  const theme = useColorModeValue("light", "dark");

  return (
    <Popover placement="top-start" isLazy={true}>
      <PopoverTrigger>
        <RiUserSmileLine color="#AFBBC6" fontSize={"1.5em"} cursor="pointer" />
      </PopoverTrigger>
      <PopoverContent
        mt="-400px"
        bg="transparent"
        boxShadow="none"
        border="none"
      >
        <PopoverArrow />
        <PopoverBody>
          <EmojiPicker
            width={"300px"}
            height="350px"
            theme={theme}
            searchDisabled={true}
            skinTonesDisabled={true}
            lazyLoadEmojis={true}
            onEmojiClick={onClick}
            autoFocusSearch={false}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default EmojiSelector;
